import { ActionKeys } from '~/actions/constants';
import * as TokenActions from '~/actions/token.actions';
import { AxiosResponse } from 'axios';
import { call, takeLatest } from 'redux-saga/effects';
import * as tokenService from '~/services/token.service';

export function* generateToken(action: ReturnType<typeof TokenActions.generateToken>) {
  try {
    const response: AxiosResponse<unknown> = yield call(
      tokenService.generateToken,
      action.payload.isTest,
    );
    action.callback(response.data);
  } catch (err) {
    action.callback(err);
  }
}

export function* getToken(action: ReturnType<typeof TokenActions.getToken>) {
  try {
    const response: AxiosResponse<{ results: unknown }> = yield call(tokenService.getToken);
    action.callback(response.data.results);
  } catch (err) {
    action.callback(err);
  }
}

export function* deleteToken(action: ReturnType<typeof TokenActions.deleteToken>) {
  try {
    const response: AxiosResponse<{ results: unknown }> = yield call(
      tokenService.deleteToken,
      action.payload.token,
    );
    action.callback(response.data.results);
  } catch (err) {
    action.callback(err);
  }
}

export default [
  takeLatest(ActionKeys.GENERATE_TOKEN, generateToken),
  takeLatest(ActionKeys.FETCH_TOKEN, getToken),
  takeLatest(ActionKeys.DELETE_TOKEN, deleteToken),
];
